export const partners = ["asurion", "verizon", "att", "tmobile", "cricket", "adt", "amazonrouter", "hpsales"];
export const lobs = ["soluto", "mobility", "care"];
